import { useCheckRequest } from '../transactions/useCheckRequest';
import { useWalletLoader } from './useWalletLoader';
import { useWalletTabs } from './useWalletTabs';
import { useWalletStatement } from './useWalletStatement';
import { useWalletActions } from './useWalletActions';
import { useWalletNavigation } from './useWalletNavigation';
import { useWalletDocument } from './useWalletDocument';
import { useWalletPayment } from './useWalletPayment';
import { useSupportWindowUtils } from '@/utils/supportWindowUtils';
import { useWalletsStore } from '~/stores/wallets/wallets-store';

export const useWallets = () => {
  const { openAddLogCommentModal, userInfos } = storeToRefs(useWalletsStore());
  const { openSupportWindow, openSupportWindowHandler } = useSupportWindowUtils();
  const { checkMoneyOutValidationConfig } = useCheckRequest();

  const loader = useWalletLoader();
  const tabs = useWalletTabs();
  const statement = useWalletStatement();
  const actions = useWalletActions();
  const navigation = useWalletNavigation();
  const walletDocument = useWalletDocument();
  const payment = useWalletPayment();

  const toggleOpenAddLogCommentModal = () => {
    openAddLogCommentModal.value = !openAddLogCommentModal.value;
  };

  const hasWireTransferValidation = (isMyWallet: boolean) =>
    checkPermission(isMyWallet ? 'proRequestWireTransfer' : 'requestWireTransfer') &&
    checkMoneyOutValidationConfig();

  const wireTransferTitle = (isMyWallet: boolean) =>
    hasWireTransferValidation(isMyWallet)
      ? 'wallets.bankAccounts.requestMoneyOut'
      : 'wallets.bankAccounts.doMoneyOut';

  return {
    ...loader,
    ...tabs,
    ...statement,
    ...actions,
    ...navigation,
    addDocumentBody: walletDocument.addDocumentBody,
    handleOpenAddDocumentModal: walletDocument.handleOpenAddDocumentModal,
    handleOpenEditDocumentModal: walletDocument.handleOpenEditDocumentModal,
    submitAddDocument: walletDocument.submitAddDocument,
    toggleDisableModal: payment.toggleDisableModal,
    toggleEnableModal: payment.toggleEnableModal,
    toggleOpenDisablePaymentFormModal: payment.toggleOpenDisablePaymentFormModal,
    toggleOpenDisableSddMandateModal: payment.toggleOpenDisableSddMandateModal,
    toggleOpenDisableSavedCardsModal: payment.toggleOpenDisableSavedCardsModal,
    handleDisable: payment.handleDisable,
    handleDisableVirtualIban: payment.handleDisableVirtualIban,
    handleEnable: payment.handleEnable,
    toggleOpenViewPaymentForm: payment.toggleOpenViewPaymentForm,
    toggleRequestDebit: payment.toggleRequestDebit,
    toggleRequestDebitModal: payment.toggleRequestDebitModal,
    handleTextCopy: payment.handleTextCopy,
    userInfos,
    openSupportWindow,
    openSupportWindowHandler,
    checkMoneyOutValidationConfig,
    toggleOpenAddLogCommentModal,
    hasWireTransferValidation,
    wireTransferTitle
  };
};
